import { Component } from '@angular/core';

@Component({
    selector: 'app-breadcrumb-company-add',
    templateUrl: './breadcrumb.company.add.component.html'
})

export class BreadcrumbCompanyAddComponent { }
